export default __webpack_public_path__ + "static/media/Valentine.63bb09ff.m4a";